<template>
  <gd-modal
    ref="noStorageModal"
    name="no-storage-connected-modal"
    :title="$t('frontend_groovevideo_videos_index_connect_your')"
  >
    <div class="flex flex-col items-center justify-center p-8">
      <p class="text-lg leading-loose mb-8 text-grey-800 text-center">
        <b>
          {{ $t('frontend_groovevideo_videos_index_free_storage_100gb') }}
        </b>
        {{ $t('frontend_groovevideo_videos_index_is_only_avaialable') }}
        <b> {{ $t('frontend_groovevideo_videos_index_pro_members') }}</b
        >. {{ $t('frontend_groovevideo_videos_index_free_members') }}
      </p>
      <div class="flex flex-col items-center justify-center">
        <a
          @click="goToUpgradePage"
          class="
            flex
            items-center
            px-6
            py-3
            heading-sm
            focus:outline-none
            shadow
            hover:shadow-lg
            focus:shadow-lg
            rounded-lg
            bg-pink-dark
            text-white
            border-pink-dark border border-solid
            text-lg
            cursor-pointer
          "
        >
          {{ $t('frontend_groovevideo_videos_index_upgrade_topro') }}
        </a>
        <button
          class="mb-10 mt-6 focus:outline-none"
          @click="$router.push({ name: 'settings' })"
        >
          {{ $t('frontend_groovevideo_videos_index_no_thanks') }}
        </button>
      </div>
    </div>
  </gd-modal>
</template>

<script>
import helpers from '@/mixins/upgradeHelper.js';

export default {
  mixins: [helpers],
  methods: {
    open() {
      this.$refs.noStorageModal.open();
    },
  },
};
</script>
